define([
	"dojo/_base/declare",
	"csi/def/Action",
	"csi/heading/AttributeComment",
	"csi/widget/MessageDialog",
	"csi/xml"
], function(declare,Action,AttributeComment,MessageDialog,xml) {

	return declare(AttributeComment, {
		constructor: function(def) {
			this.classController = "csi.heading.CommentResetController";
			this.confirmAction = MessageDialog.BUTTON_RESET;
			this.m_id = "ActionCommentReset";
		},

		checkNodeAccess: function(/*Node*/node) {
			var	id = this.heading.m_id;
			return this.inherited(arguments) && node && (node[xml.idGetComment(id)] || node[xml.idGetCommentColor(id)]);
		}
	});
});